import { ENV } from '../config/constant';
import { axios } from '../config/axios';
const { VUE_APP_API_HOST_ZLZ: HOST } = ENV;

/**
 * 查询修缮记录
 * @param {Object} params
 * @param {Boolean} params.acceptanceDateSort
 * @param {Boolean} params.completionDateSort
 * @param {stirng} params.keyword
 * @param {number} params.page
 * @param {number} params.pageSize
 */
export function GetRepairList(params) {
  return axios.post(`${HOST}/repairRecord/table`, params, {
    headers: { 'Content-Type': 'application/json' }
  });
}

/**
 * 删除修缮记录
 * @param {string} repairRecordUid 修缮记录id
 */
export function DeleteRepairData(repairRecordUid) {
  return axios.delete(
    `${HOST}/repairRecord?repairRecordUid=${repairRecordUid}`
  );
}

/**
 * 修改修缮记录
 * @param {Object} params
 * @param {string} params.acceptanceDate  验收日期
 * @param {string} params.completionDate  竣工日期
//  * @param {string} params.completionReport 
//  * @param {string} params.constructionScheme
 * @param {string} params.constructionUnit 施工单位
 * @param {string} params.constructionUnitContact 施工单位电话
//  * @param {string} params.designScheme
//  * @param {string} params.investigationReport
 * @param {string} params.ownerUnit 业主单位
 * @param {string} params.ownerUnitContact 业主联系方式
 * @param {string} params.relicFromUserId 用户自定义id
 * @param {string} params.relicName 建筑名称
 * @param {string} params.relicAutoIncrementId 建筑自增id
 * @param {string} params.remark 备注
 * @param {array} params.photoList  修缮前竣工后照片
 * @param {array} params.fileList  文件合集
 */
export function UpdateRepairData(params) {
  return axios.put(
    `${HOST}/repairRecord?repairRecordUid=${params.repairRecordUid}
  `,
    params,
    {
      headers: { 'Content-Type': 'application/json' }
    }
  );
}

/**
 * 新增修缮记录
 * @param {Object} params
 * @param {string} params.acceptanceDate  验收日期
 * @param {string} params.completionDate  竣工日期
//  * @param {string} params.completionReport 
//  * @param {string} params.constructionScheme
 * @param {string} params.constructionUnit 施工单位
 * @param {string} params.constructionUnitContact 施工单位电话
//  * @param {string} params.designScheme
//  * @param {string} params.investigationReport
 * @param {string} params.ownerUnit 业主单位
 * @param {string} params.ownerUnitContact 业主联系方式
 * @param {string} params.relicFromUserId 用户自定义id
 * @param {string} params.relicName 建筑名称
 * @param {string} params.relicAutoIncrementId 建筑自增id
 * @param {string} params.remark 备注
 * @param {array} params.photoList  修缮前竣工后照片
 * @param {array} params.fileList  文件合集
 */
export function AddRepairRecord(params) {
  return axios.post(`${HOST}/repairRecord`, params, {
    headers: { 'Content-Type': 'application/json' }
  });
}

/**
 * 查询单个修缮记录的
 */
export function GetSingleRepairRecord(repairRecordUid) {
  return axios.get(`${HOST}/repairRecord/${repairRecordUid}`);
}
